/**
 * A component that renders a small heading in a PDF document
 * @param {string} heading - The text content of the heading
 * @param {boolean} [withBottomMargin=true] - Whether to add a bottom margin to the heading
 * @param {boolean} [withBreak] - Whether to force a page break before the heading
 * @param {number} [minPresenceAhead] - Minimum space required ahead of the heading (in points)
 * @param {object} [headingStyles] - Optional custom styles to apply to the heading
 * @returns {React.ReactElement} A React component that displays a formatted small heading
 * @see {@link https://react-pdf.org/ | React-PDF}
 */

import { StyleSheet, Text, View } from '@react-pdf/renderer';

export interface ISubHeadingProps {
  heading: string;
  withBottomMargin?: boolean;
  withBreak?: boolean;
  minPresenceAhead?: number;
  headingStyles?: object;
  containerStyles?: object;
}

export const SmallHeading = ({
  heading,
  withBottomMargin = true,
  withBreak,
  minPresenceAhead,
  headingStyles,
  containerStyles = {},
}: ISubHeadingProps) => (
  <>
    <View minPresenceAhead={minPresenceAhead} />
    <View style={{ marginBottom: withBottomMargin ? 19 : 0, ...containerStyles }} break={withBreak}>
      <Text style={{ ...styles.subHeading, ...headingStyles }}>{heading}</Text>
    </View>
  </>
);

const styles = StyleSheet.create({
  subHeading: {
    fontFamily: 'Noto',
    fontSize: '10px',
    color: '#212121',
    lineHeight: 1.4,
    fontWeight: 700,
  },
});
